import { ActionType } from "../types";
import {
  InfrastructureApplications,
  InfrastructureApplicationsAction,
} from "../types/infrastructure-applications";

export const infrastructureApplications = (
  state: InfrastructureApplications = {},
  action: InfrastructureApplicationsAction
): InfrastructureApplications => {
  switch (action.type) {
    case ActionType.GET_INFRASTRUCTURE_APPLICATIONS_REQUEST:
      return {
        ...state,
        [action.key]: null,
      };
    case ActionType.GET_INFRASTRUCTURE_APPLICATIONS_SUCCESS:
      return {
        ...state,
        [action.key]: action.infrastructureApplications,
      };
    case ActionType.GET_INFRASTRUCTURE_APPLICATIONS_FAILURE:
      return {
        ...state,
        [action.key]: null,
      };
    default:
      return state;
  }
};
